import type { PlayerPaymentOrder } from "./api";

/**
 * Liga de «Pagar ahora» / «Pagar» de una orden pendiente del jugador.
 *
 * Adela 2026-10-23: en una cuenta familiar con dos hijos con pago pendiente,
 * la liga del paso de pago era la misma para los dos y la página abría
 * siempre al primero. La liga del paso de pago (`?paso=pago`) siempre lleva
 * el perfil y la orden de ESE hijo; si el servidor todavía manda la liga sin
 * ellos, se agregan aquí. La página de pago solo los usa si son de la cuenta.
 */
export function orderPaymentHref(
  order: Pick<PlayerPaymentOrder, "payment_url" | "player_profile_id" | "public_token">,
): string {
  const url = order.payment_url;
  const queryAt = url.indexOf("?");
  if (queryAt < 0) return url;
  const params = new URLSearchParams(url.slice(queryAt + 1));
  if (params.get("paso") !== "pago") return url;
  if (order.player_profile_id && !params.has("perfil")) params.set("perfil", String(order.player_profile_id));
  if (order.public_token && !params.has("orden")) params.set("orden", order.public_token);
  return `${url.slice(0, queryAt)}?${params.toString()}`;
}
